import React from 'react';

interface ChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
  disabled?: boolean;
}

const Chip: React.FC<ChipProps> = function ({ label, active, onClick, icon, disabled }) {
  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      title={disabled ? 'Not available at this level' : undefined}
      className={
        'flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-xs font-semibold transition-colors border whitespace-nowrap ' +
        (disabled
          ? 'bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed'
          : active
            ? 'bg-[#F36B21] text-white border-[#F36B21]'
            : 'bg-white text-gray-600 border-gray-200 hover:border-[#F36B21] hover:text-[#F36B21]')
      }
    >
      {icon}
      {label}
    </button>
  );
};

export default Chip;
